export const getErrorMessage = (error) => {
  if (!error) return '';
  return error.message || error.response?.body?.message || error.response?.text || error.error || '';
};

export const getEndedReasonFromErrorMessage = (message = '') => {
  const normalized = String(message || '').toLowerCase();

  if (normalized.includes('not a part of this chat')) {
    return 'not-participant';
  }

  if (normalized.includes('chat not found') || normalized.includes('meeting not found')) {
    return 'invalid';
  }

  return 'unavailable';
};

const normalizeError = (error) => {
  const rawMessage = typeof error === 'string' ? error : (error?.message || '');
  return {
    message: `${rawMessage}`.toLowerCase(),
    name: `${error?.name || ''}`.toLowerCase(),
  };
};

export const isDeviceAccessError = (error) => {
  const { message, name } = normalizeError(error);

  return (
    name.includes('notallowederror')
    || name.includes('permission')
    || name.includes('notfounderror')
    || name.includes('notreadableerror')
    || message.includes('permission')
    || message.includes('not allowed')
    || message.includes('requested device not found')
    || message.includes('could not start')
    || message.includes('device')
  );
};

export const isContentShareUserCancelError = (error) => {
  const { message, name } = normalizeError(error);

  return (
    name === 'aborterror'
    || message.includes('permission denied by user')
    || message.includes('permission denied')
    || message.includes('denied permission')
    || message.includes('user denied permission')
    || message.includes('the user denied permission')
    || message.includes('denied by user')
    || message.includes('permission dismissed')
    || message.includes('request is dismissed')
    || message.includes('user cancelled')
    || message.includes('user canceled')
    || message.includes('cancelled')
    || message.includes('canceled')
  );
};
